import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { $fetch } from 'ofetch'

export default defineNuxtRouteMiddleware(async (nuxtApp) => {
  const user = useSupabaseUser()
  const buuid = nuxtApp.params?.buuid

  if (!user?.value?.id) {
    return navigateTo('/auth/login')
  }

  try {
    await $fetch(`/api/user/${user?.value?.id}/${buuid}`)
  }
  catch {
    console.error('error')
    return navigateTo('/access-denied')
  }
})
